import QRP from '../QRP.env';

let fallbackDataRcTwo = {};
fallbackDataRcTwo = {
  pageData: {
    page_name: 'Rc2PropertyDetails',
    fields: [
      {
         field_name :  'QTE_PRP_YearBuilt' ,
         field_type :  'input_number' ,
         label :  'Year Built' ,
         field_value :  '1978' ,
         group_id : '11',
         index : null,
         sub_index : null,
         display_order : 10,
         section_display_order : 0,
         help_text : '',
         sub_text :'',
         placeholder :'YYYY' ,
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'',
         max_length : 4,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :'FieldRequired',
             rule :'{ required : true }',
             rule_url :''
          },
          {
             rule_type :'api' ,
             trigger : 'onblur' ,
             rule_name :'ValidateYearBuiltDependentDates' ,
             rule :'', 
             rule_url :'/rules/ValidateYearBuiltDependentDates/QTE_PRP_YearBuilt',
          }
        ],
         values : [],
         has_error : 'false',
         error : 'null'
      },
      {
         field_name : 'QTE_PRP_SquareFootage' ,
         field_type : 'input_number' ,
         label : 'Square Footage' ,
         field_value :'1641' ,
         group_id : '11',
         index : null,
         sub_index : null,
         display_order : 20,
         section_display_order : 0,
         help_text :'', 
         sub_text :'Sq Ft' ,
         placeholder :'', 
         visible : true,
         is_quote_summary_field : 'false',
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 5,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'',
         rules : [
          {
             rule_type : 'js' ,
             trigger :'', 
             rule_name :'RequiredMax5Digit' ,
             rule :'{ \ required\ : true, \ min_value\ : 0, \ max_value\ : 99999 }',
             rule_url :'',  
          }
        ],
         values : [],
         has_error : 'false',
         error : 'null'
      },
      {
         field_name : 'QTE_PRP_PurchaseDate' ,
         field_type : 'date_short' ,
         label :'Purchase Date' ,
         field_value :'20210203' ,
         group_id :'11',
         index : null,
         sub_index : null,
         display_order :30,
         section_display_order : 0,
         help_text :'', 
         sub_text :'', 
         placeholder : 'MM/DD/YYYY' ,
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 8,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js',
             trigger :'', 
             rule_name : 'RequiredDateFormat' ,
             rule : '{ \ required\ : true, \ date_format\ : \ MM/DD/YYYY\  }' ,
             rule_url :''   
          },
          {
             rule_type :'api' ,
             trigger :'onblur',
             rule_name :'ValidatePurchaseDate' ,
             rule :'', 
             rule_url :'/rules/ValidatePurchaseDate/QTE_PRP_PurchaseDate '
          }
        ],
         values : [
          
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_PurchasePrice' ,
         field_type : 'money_medium' ,
         label : 'Purchase Price' ,
         field_value : '250000' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 40,
         section_display_order : 0,
         help_text :'', 
         sub_text :'', 
         placeholder :  '$' ,
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 7,
         section :'General Information' ,
         section_type :'',
         sub_section :'',
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'RequiredMax7Digit' ,
             rule :'{ \ required\ : true, \ min_value\ : 0, \ max_value\ : 9999999 }' ,
             rule_url : '' 
          }
        ],
         values : [
          
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_EstimatedValue' ,
         field_type :'money_medium' ,
         label :'Dwelling Market Value' ,
         field_value :'250000' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 50,
         section_display_order : 0,
         help_text :'', 
         sub_text :'', 
         placeholder :  '$' ,
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 7,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'RequiredMax7Digit' ,
             rule :'{ \ required\ : true, \ min_value\ : 0, \ max_value\ : 9999999 }' ,
             rule_url : ''  
          }
        ],
         values : [
          
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_DwellingType' ,
         field_type : 'select_medium' ,
         label :'Dwelling Type' ,
         field_value :'OneFamily' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 60,
         section_display_order : 0,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :'One Family',
             internal_value :'OneFamily' ,
             visible : true,
             display_order : 1
          },
          {
             display_value : 'Two Family' ,
             internal_value :'TwoFamily' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :'Three Family' ,
             internal_value :'ThreeFamily' ,
             visible : true,
             display_order : 3
          },
          {
             display_value :'Four Family' ,
             internal_value :'FourFamily' ,
             visible : true,
             display_order : 4
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_DwellingUsage' ,
         field_type :'select_medium' ,
         label :'Dwelling Usage' ,
         field_value :'Primary' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 70,
         section_display_order : 0,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :'Primary' ,
             internal_value :'Primary' ,
             visible : true,
             display_order : 1
          },
          {
             display_value : 'Secondary' ,
             internal_value : 'Secondary' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :'Seasonal' ,
             internal_value :'Seasonal' ,
             visible : true,
             display_order : 3
          },
          {
             display_value :'Farm',
             internal_value :'Farm' ,
             visible : true,
             display_order : 4
          },
          {
             display_value :'Course of Construction' ,
             internal_value :'COC' ,
             visible : true,
             display_order : 5
          },
          {
             display_value :'Unoccupied' ,
             internal_value :'Unoccupied' ,
             visible : true,
             display_order : 6
          },
          {
             display_value :'Vacant' ,
             internal_value :'Vacant' ,
             visible : true,
             display_order : 7
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_IsPropertyUnderConstruction' ,
         field_type :  'radio' ,
         label :'Is this dwelling under construction?' ,
         field_value :  'N' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 80,
         section_display_order : 0,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :'Yes' ,
             internal_value :'Y' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'No' ,
             internal_value :  'N' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_IsPropertyInsideCityLimits' ,
         field_type :'radio' ,
         label :'Is this dwelling inside the city limits?' ,
         field_value :'Y' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 90,
         section_display_order : 0,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js ',
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url :''  
          }
        ],
         values : [
          {
             display_value :'Yes' ,
             internal_value :'Y' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'No' ,
             internal_value : 'N' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_IsPropertyWithinFireDistrict' ,
         field_type :  'radio' ,
         label :'Is this dwelling within a fire district?' ,
         field_value :  'Y',
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 100,
         section_display_order : 0,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url : ''  
          }
        ],
         values : [
          {
             display_value :'Yes' ,
             internal_value :'Y' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :'No' ,
             internal_value :'N' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_DistanceFromFireStation' ,
         field_type :'input_number' ,
         label :'The dwelling distance from the nearest fire station?' ,
         field_value :  2 ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 110,
         section_display_order : 0,
         help_text :'', 
         sub_text :  'Miles' ,
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 3,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'RequiredNumericMinValueOne' ,
             rule :'{ \ required\ : true, \ numeric\ : true, \ min_value\ : 1 }' ,
             rule_url :''   
          },
          {
             rule_type :'api' ,
             trigger : 'onblur' ,
             rule_name :'ManageFireProtectionClass' ,
             rule :'', 
             rule_url :'/rules/ManageFireProtectionClass/QTE_PRP_DistanceFromFireStation' 
          }
        ],
         values : [
          
        ],
         has_error :'false',
         error :'null'
      },
      {
         field_name :'QTE_PRP_DistanceFromFireHydrant' ,
         field_type :'select_medium' ,
         label :'The dwelling distance from a fire hydrant?' ,
         field_value :'1-500' ,
         group_id :'11',
         index :'null',
         sub_index :'null',
         display_order :120,
         section_display_order : 0,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url :''   
          },
          {
             rule_type :'api' ,
             trigger :'onchange' ,
             rule_name :'ManageFireProtectionClass' ,
             rule :'', 
             rule_url :'/rules/ManageFireProtectionClass/QTE_PRP_DistanceFromFireHydrant' 
          }
        ],
         values : [
          {
             display_value :'None' ,
             internal_value :'None' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :'1 - 500 ft.' ,
             internal_value :'1-500' ,
             visible :true,
             display_order : 2
          },
          {
             display_value :'501 - 600 ft.' ,
             internal_value :'501-600' ,
             visible : true,
             display_order : 3
          },
          {
             display_value :'601 - 1,000 ft.' ,
             internal_value :'601-1000' ,
             visible : true,
             display_order : 4
          },
          {
             display_value :'1,001 ft. or Greater' ,
             internal_value :'1001+' ,
             visible : true,
             display_order : 5
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_FireProtectionClass' ,
         field_type :'select_medium' ,
         label :'What is the dwellings fire protection class?' ,
         field_value :'Class5' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 130,
         section_display_order : 0,
         help_text :'<p><strong>Protection Class 1-7:</strong> A responding fire department is located within 5 miles and a fire hydrant is located within 1,000 feet.</p><p><strong>Protection Class 8:</strong> A responding fire department is located within 5 miles and there is a “dry hydrant” located near the dwelling that is connected to a reliable water source (lake or river). A pumping truck can hook-up and pump water onto the dwelling instead of relying on pressure from a normal hydrant.</p><p><strong>Protection Class 9:</strong> A responding fire department is located within 5 miles and there are no fire hydrants within 1,000 feet.</p><p><strong>Protection Class 10:</strong> There is no fire department within 5 miles of the dwelling and no fire hydrant located within 1,000 feet.</p>' ,
         sub_text :'The dwelling location saftey rating is dictated by the ISO protection class rating.' ,
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js ',
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url : ''  
          }
        ],
         values : [
          {
             display_value :'Class 1' ,
             internal_value :'Class1' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :'Class 2' ,
             internal_value :'Class2' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :'Class 3' ,
             internal_value :'Class3' ,
             visible : true,
             display_order : 3
          },
          {
             display_value :'Class 4' ,
             internal_value :'Class4' ,
             visible : true,
             display_order : 4
          },
          {
             display_value :'Class 5' ,
             internal_value :'Class5' ,
             visible : true,
             display_order : 5
          },
          {
             display_value :'Class 6' ,
             internal_value :'Class6' ,
             visible : true,
             display_order : 6
          },
          {
             display_value :'Class 7' ,
             internal_value :'Class7' ,
             visible : true,
             display_order : 7
          },
          {
             display_value :'Class 8' ,
             internal_value :'Class8' ,
             visible : true,
             display_order : 8
          },
          {
             display_value :'Class 9' ,
             internal_value :'Class9' ,
             visible : true,
             display_order : 9
          },
          {
             display_value :'Class 10' ,
             internal_value :'Class10' ,
             visible : true,
             display_order : 10
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_IsPartOfCommunity' ,
         field_type :  'radio' ,
         label :'Is this dwelling part of a community?' ,
         field_value :  'N' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 140,
         section_display_order : 0,
         help_text :'', 
         sub_text :'Community Examples: Retirement, Manned Security, Gated, etc.' ,
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url :''   
          },
          {
             rule_type : 'api' ,
             trigger : 'onchange' ,
             rule_name :'ManageIsPartOfCommunity' ,
             rule :'', 
             rule_url :'/rules/ManageIsPartOfCommunity/QTE_PRP_IsPartOfCommunity' 
          }
        ],
         values : [
          {
             display_value :'Yes' ,
             internal_value :'Y' ,
             visible : 'true',
             display_order : 1
          },
          {
             display_value :  'No' ,
             internal_value :  'N' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_CommunityType' ,
         field_type : 'multicheckbox' ,
         label :'Community Type' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 150,
         section_display_order : 0,
         help_text :'', 
         sub_text : 'Select all that apply.' ,
         placeholder :'', 
         visible : false,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name : 'FieldRequired',
             rule :'{ \ required\ : true }',
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :'Gated' ,
             internal_value :'GatedCommunity' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :'Limited Access' ,
             internal_value :'LimitedAccessCommunity' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :'Manned Security' ,
             internal_value :'MannedSecurityCommunity' ,
             visible : true,
             display_order : 3
          },
          {
             display_value :'Retirement' ,
             internal_value :'RetirementCommunity' ,
             visible : true,
             display_order : 4
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_IsPropertyAddressSameAsCurrentAddress',
         field_type :  'radio' ,
         label :'Is this dwelling address the same as your current address?' ,
         field_value :  'Y',
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 160,
         section_display_order : 0,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url : ''  
          },
          {
             rule_type :'api' ,
             trigger :'onchange' ,
             rule_name :'ManageIsPropertyAddressSameAsCurrentAddress' ,
             rule :'', 
             rule_url :'/rules/ManageIsPropertyAddressSameAsCurrentAddress/QTE_PRP_IsPropertyAddressSameAsCurrentAddress'
          }
        ],
         values : [
          {
             display_value :'Yes' ,
             internal_value :'Y' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'No' ,
             internal_value :  'N' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_MailingStreetAddress' ,
         field_type :'text_long' ,
         label :'Current Address' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 170,
         section_display_order : 1,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : false,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js ',
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_MailingAddress2' ,
         field_type :'text_long' ,
         label :'APT/Unit Number' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 180,
         section_display_order : 1,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : false,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : false,
         script :'', 
         max_length : 100,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          
        ],
         values : [
          
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_MailingCity' ,
         field_type :'text_long',
         label :  'City' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 190,
         section_display_order : 1,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : false,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url : ''  
          }
        ],
         values : [
          
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_MailingState' ,
         field_type :'text_inline_first' ,
         label :'State' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 200,
         section_display_order : 1,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : false,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 2,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url : ''  
          }
        ],
         values : [
          
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_MailingZipCode' ,
         field_type :'text_inline' ,
         label :'Zip Code' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 210,
         section_display_order : 1,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : false,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 5,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url :'' 
          }
        ],
         values : [
          
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_FinancialInterest' ,
         field_type :'select_medium' ,
         label :'Is there financial interest on this dwelling?' ,
         field_value :'ThirdMortgagee' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 220,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }',
             rule_url :''   
          },
          {
             rule_type :'api' ,
             trigger :'onchange' ,
             rule_name :'ManageFinancialInterest' ,
             rule :'', 
             rule_url :'/rules/ManageFinancialInterest/QTE_PRP_FinancialInterest '
          }
        ],
         values : [
          {
             display_value :'No, Fully Paid Off',
             internal_value :'PaidOff' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :'One Mortgage' ,
             internal_value :'FirstMortgagee' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :'Two Mortgages' ,
             internal_value :'SecondMortgagee' ,
             visible : true,
             display_order : 3
          },
          {
             display_value :'Three Mortgages' ,
             internal_value :'ThirdMortgagee' ,
             visible : true,
             display_order : 4
          },
          {
             display_value :'Cosigner' ,
             internal_value :'CoSigner' ,
             visible : true,
             display_order : 5
          },
          {
             display_value :'Equity Line of Credit' ,
             internal_value :'EquityLineOfCredit' ,
             visible : true,
             display_order : 6
          },
          {
             display_value :'Other Interests' ,
             internal_value :'therInterests' ,
             visible : true,
             display_order : 7
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_NumOtherInterests' ,
         field_type :'input_number' ,
         label :'Number of other Interests' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 230,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : false,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 5,
         section :  'General Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'RequiredMax5Digit' ,
             rule :'{ \ required\ : true, \ min_value\ : 0, \ max_value\ : 99999 }' ,
             rule_url :  '' 
          }
        ],
         values : [
          
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_HasSwimmingPool' ,
         field_type :'radio' ,
         label :'Does this dwelling have a swimming pool?' ,
         field_value :  'N' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 240,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url : ''  
          },
          {
             rule_type :'api' ,
             trigger :'onchange' ,
             rule_name :'ManageHasSwimmingPool' ,
             rule :'', 
             rule_url :'/rules/ManageHasSwimmingPool/QTE_PRP_HasSwimmingPool'
          }
        ],
         values : [
          {
             display_value :'Yes' ,
             internal_value :'Y' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :'No' ,
             internal_value :'N' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_SwimmingPoolType' ,
         field_type :'select_medium' ,
         label :'Swimming Pool Type' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 250,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : false,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :'Above Ground with Slide' ,
             internal_value :'AboveGroundWSlide' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :'Above Ground without Slide' ,
             internal_value :'AboveGroundWoSlide' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :'Inground with Slide' ,
             internal_value :'InGroundWSlide' ,
             visible : true,
             display_order : 3
          },
          {
             display_value :'Inground without Slide ',
             internal_value :'InGroundWoSlide' ,
             visible : true,
             display_order : 4
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_IsSwimmingPoolFenced ',
         field_type :'radio' ,
         label :'Is the swimming pool fenced?' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 260,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : false,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :'Yes' ,
             internal_value :'Y' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :'No' ,
             internal_value :'N' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_HasTrampoline' ,
         field_type :'radio' ,
         label :'Does this dwelling have a trampoline?' ,
         field_value :'N' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 270,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'FieldRequired' ,
             rule :'{ \ required\ : true }' ,
             rule_url :''   
          },
          {
             rule_type :'api' ,
             trigger :'onchange' ,
             rule_name :'ManageHasTrampoline' ,
             rule :'', 
             rule_url :'/rules/ManageHasTrampoline/QTE_PRP_HasTrampoline' 
          }
        ],
         values : [
          {
             display_value :'Yes' ,
             internal_value :'Y' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :'No' ,
             internal_value :'N' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_IsTrampolineFenced' ,
         field_type :  'radio' ,
         label :  'Is the trampoline fenced?' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 280,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : false,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name : 'FieldRequired' ,
             rule : '{ \ required\ : true }' ,
             rule_url : ''  
          }
        ],
         values : [
          {
             display_value :'Yes' ,
             internal_value :'Y' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :'No' ,
             internal_value : 'N' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name : 'QTE_PRP_HasDetachedStructures' ,
         field_type :  'radio' ,
         label :  'Does this dwelling have any detached structures?' ,
         field_value :  'N' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 290,
         section_display_order : 2,
         help_text :'', 
         sub_text : 'Larger structures may require more coverage.' ,
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name : 'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url :''   
          },
          {
             rule_type :  'api' ,
             trigger :  'onchange' ,
             rule_name :  'ManageHasDetachedStructures' ,
             rule :'', 
             rule_url : '/rules/ManageHasDetachedStructures/QTE_PRP_HasDetachedStructures' 
          }
        ],
         values : [
          {
             display_value : 'Yes' ,
             internal_value :  'Y' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'No' ,
             internal_value :  'N' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_DetachedStructureType' ,
         field_type :  'select_medium' ,
         label :  'Structure Type' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 300,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : false,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name : 'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url : ''  
          }
        ],
         values : [
          {
             display_value : 'Hot Tub/Jacuzzi' ,
             internal_value :  'HotTubJacuzzi' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'Small Shed (Less than 10 x 10)' ,
             internal_value :  'ShedSmall' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :  'Medium Shed (Larger than 10 x 10 Less than 10 x 20)' ,
             internal_value :  'ShedMedium' ,
             visible : true,
             display_order : 3
          },
          {
             display_value :  'Large Shed (10 x 20 or Larger)' ,
             internal_value :  'ShedLarge' ,
             visible : true,
             display_order : 4
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_HasPorch' ,
         field_type :  'radio' ,
         label :  'Does this dwelling have a porch?' ,
         field_value :  'Y',
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 310,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url : ''  
          },
          {
             rule_type :  'api' ,
             trigger :  'onchange' ,
             rule_name : 'ManageHasPorch' ,
             rule :'', 
             rule_url :  '/rules/ManageHasPorch/QTE_PRP_HasPorch' 
          }
        ],
         values : [
          {
             display_value :  'Yes' ,
             internal_value :  'Y' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'No' ,
             internal_value :  'N' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_PorchType' ,
         field_type :  'select_long' ,
         label :  'Porch Type' ,
         field_value :  'EnclosedPorch' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 320,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js ',
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule : '{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :'Enclosed Breezeways' ,
             internal_value :'EnclosedBreezeways' ,
             visible : true,
             display_order : 1
          },
          {
             display_value : 'Enclosed Porch' ,
             internal_value :  'EnclosedPorch' ,
             visible : true,
             display_order : 2
          },
          {
             display_value : 'Open Breezeways' ,
             internal_value :  'OpenBreezeways' ,
             visible : true,
             display_order : 3
          },
          {
             display_value : 'Open Porch' ,
             internal_value :  'OpenPorch' ,
             visible : true,
             display_order : 4
          },
          {
             display_value :  'Redwood Deck' ,
             internal_value :  'RedwoodDeck' ,
             visible : true,
             display_order : 5
          },
          {
             display_value : 'Screened Breezeways' ,
             internal_value :  'ScreenedBreezeways' ,
             visible : true,
             display_order : 6
          },
          {
             display_value :  'Screened Porch' ,
             internal_value :  'ScreenedPorch' ,
             visible : true,
             display_order : 7
          },
          {
             display_value : 'Sun Solar Room' ,
             internal_value :  'SunSolarRoom' ,
             visible : true,
             display_order : 8
          },
          {
             display_value :  'Wood Deck' ,
             internal_value :  'WoodDeck' ,
             visible : true,
             display_order : 9
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_PorchSquareFootage' ,
         field_type :  'input_number' ,
         label :  'Porch Square Footage' ,
         field_value :  20 ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 330,
         section_display_order : 2,
         help_text :'', 
         sub_text :  'Sq Ft' ,
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 5,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name : 'RequiredMax5Digit' ,
             rule :'{ \ required\ : true, \ min_value\ : 0, \ max_value\ : 99999 }',
             rule_url :''   
          },
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'RequiredMax5Digit' ,
             rule :'{ \ required\ : true, \ min_value\ : 0, \ max_value\ : 99999 }' ,
             rule_url :''   
          },
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'RequiredMax5Digit' ,
             rule :'{ \ required\ : true, \ min_value\ : 0, \ max_value\ : 99999 }' ,
             rule_url :''   
          },
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'RequiredMax5Digit' ,
             rule :'{ \ required\ : true, \ min_value\ : 0, \ max_value\ : 99999 }' ,
             rule_url :'' 
          },
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name : 'RequiredMax5Digit' ,
             rule :'{ \ required\ : true, \ min_value\ : 0, \ max_value\ : 99999 }' ,
             rule_url :''   
          },
          {
             rule_type :'js' ,
             trigger :'', 
             rule_name :'RequiredMax5Digit' ,
             rule :'{ \ required\ : true, \ min_value\ : 0, \ max_value\ : 99999 }' ,
             rule_url :''   
          }
        ],
         values : [
          
        ],
         has_error : false,
         error : null
      },
      {
         field_name :'QTE_PRP_DistanceFromTidalWater' ,
         field_type :'select_medium' ,
         label :'How many miles is this dwelling from tidal water? ',
         field_value :'5+' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 340,
         section_display_order : 2,
         help_text :'', 
         sub_text :'Miles' ,
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          
        ],
         values : [
          {
             display_value : '0 - 0.5 Miles' ,
             internal_value : '0-.5' ,
             visible : true,
             display_order : 1
          },
          {
             display_value : '0.5 - 1 Miles' ,
             internal_value :  '.5-1' ,
             visible : true,
             display_order : 2
          },
          {
             display_value : '1 - 2 Miles' ,
             internal_value :  '1-2' ,
             visible : true,
             display_order : 3
          },
          {
             display_value : '2 - 5 Miles' ,
             internal_value : '2-5' ,
             visible : true,
             display_order : 4
          },
          {
             display_value : 'More Than 5 Miles' ,
             internal_value : '5+' ,
             visible : true,
             display_order : 5
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name : 'QTE_PRP_SafetyFeatures',
         field_type :  'multicheckbox' ,
         label :  'Safety Features' ,
         field_value :  'FireDetector,SmokeDetector,DeadBolt,BurglarAlarm' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 350,
         section_display_order : 2,
         help_text :'', 
         sub_text :  'Select all that apply.' ,
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : false,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'api' ,
             trigger : 'onchange' ,
             rule_name :  'ManageSafetyFeatures' ,
             rule :'', 
             rule_url :'/rules/ManageSafetyFeatures/QTE_PRP_SafetyFeatures' 
          }
        ],
         values : [
          {
             display_value : 'Burglar Alarm' ,
             internal_value : 'BurglarAlarm',
             visible : true,
             display_order : 1
          },
          {
             display_value :  'Dead Bolt' ,
             internal_value :  'DeadBolt' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :  'Fire Detector' ,
             internal_value :  'FireDetector' ,
             visible : true,
             display_order : 3
          },
          {
             display_value :  'Fire Extinguisher' ,
             internal_value :  'FireExtinguisher' ,
             visible : true,
             display_order : 4
          },
          {
             display_value :  'Smoke Detector' ,
             internal_value :  'SmokeDetector' ,
             visible : true,
             display_order : 5
          },
          {
             display_value :  'Indoor Sprinkler System' ,
             internal_value :  'IndoorSprinklerSystem' ,
             visible : true,
             display_order : 6
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_BurglarAlarmType' ,
         field_type :  'radio' ,
         label :  'Burglar Alarm Type' ,
         field_value :  'Central' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 360,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule : '{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :  'Central' ,
             internal_value :  'Central' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'Direct' ,
             internal_value :  'Direct' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :  'Local' ,
             internal_value :  'Local' ,
             visible : true,
             display_order : 3
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_FireDetectorType' ,
         field_type :  'radio' ,
         label :  'Fire Detector Type' ,
         field_value :  'Central' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 370,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :  'Central' ,
             internal_value :  'Central' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'Direct' ,
             internal_value :  'Direct' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :  'Local' ,
             internal_value :  'Local' ,
             visible : true,
             display_order : 3
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_SmokeDetectorType' ,
         field_type :  'radio' ,
         label :  'Smoke Detector Type' ,
         field_value :  'Central' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 380,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :  'Central' ,
             internal_value :  'Central' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'Direct' ,
             internal_value :  'Direct' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :  'Local' ,
             internal_value :  'Local' ,
             visible : true,
             display_order : 3
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_IndoorSprinklerSystemType' ,
         field_type :  'radio' ,
         label :  'Indoor Sprinkler System Type' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 390,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : false,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :'', 
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :  'Full' ,
             internal_value :  'Full' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'Partial' ,
             internal_value :  'Partial' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_PrimaryHeatingSource' ,
         field_type :  'select_medium' ,
         label :  'Primary Heating Source' ,
         field_value :  'Central' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 400,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :  'Utility Information' ,
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js ',
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :  'Central' ,
             internal_value :  'Central' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'Electric' ,
             internal_value :  'Electric' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :  'Gas' ,
             internal_value :  'Gas' ,
             visible : true,
             display_order : 3
          },
          {
             display_value :  'Gas (Forced Air)' ,
             internal_value :  'GasForcedAir' ,
             visible : true,
             display_order : 4
          },
          {
             display_value :  'Gas (Hot Water)' ,
             internal_value :  'GasHot Water' ,
             visible : true,
             display_order : 5
          },
          {
             display_value :  'Oil' ,
             internal_value :  'Oil' ,
             visible : true,
             display_order : 6
          },
          {
             display_value :  'Oil (Forced Air)' ,
             internal_value :  'OilForcedAir' ,
             visible : true,
             display_order : 7
          },
          {
             display_value :  'Oil (Hot Water)' ,
             internal_value :  'OilHotWater' ,
             visible : true,
             display_order : 8
          },
          {
             display_value :  'Solid Fuel' ,
             internal_value :  'SolidFuel' ,
             visible : true,
             display_order : 9
          },
          {
             display_value :  'Other' ,
             internal_value :  'Other' ,
             visible : true,
             display_order : 10
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_SecondaryHeatingSource' ,
         field_type :  'radio' ,
         label :  'Secondary Heating Source' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 410,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :  'Utility Information' ,
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url :''   
          },
          {
             rule_type :  'api' ,
             trigger :  'onchange' ,
             rule_name :  'ManageSecondaryHeatingSource' ,
             rule :'', 
             rule_url :  '/rules/ManageSecondaryHeatingSource/QTE_PRP_SecondaryHeatingSource' 
          }
        ],
         values : [
          {
             display_value :  'Yes' ,
             internal_value :  'Y' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'No' ,
             internal_value :  'N' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : true,
         error : 'Required' 
      },
      {
         field_name :  'QTE_PRP_SecondaryHeatingSourceType' ,
         field_type :  'select_medium' ,
         label :  'Secondary Heating Source Type' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 420,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : false,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :  'Utility Information' ,
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :  'Coal (Non-professional Installed)' ,
             internal_value :  'CoalNPI' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'Coal (Professional Installed)' ,
             internal_value :  'CoalPI' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :  'Electric Portable Heater' ,
             internal_value :  'ElectricPortableHeater' ,
             visible : true,
             display_order : 3
          },
          {
             display_value :  'Electric' ,
             internal_value :  'Electric' ,
             visible : true,
             display_order : 4
          },
          {
             display_value :  'Kerosene' ,
             internal_value :  'Kerosene' ,
             visible : true,
             display_order : 5
          },
          {
             display_value :  'Kerosene Portable Heater' ,
             internal_value :  'KerosenePortableHeater' ,
             visible : true,
             display_order : 6
          },
          {
             display_value :  'Liquid Propane' ,
             internal_value :  'LiquidPropane' ,
             visible : true,
             display_order : 7
          },
          {
             display_value :  'Liquid Propane Portable Heater' ,
             internal_value :  'LiquidPropanePortable Heater' ,
             visible : true,
             display_order : 8
          },
          {
             display_value : 'Natural Gas' ,
             internal_value :  'NaturalGas' ,
             visible : true,
             display_order : 9
          },
          {
             display_value :  'Oil' ,
             internal_value :  'Oil' ,
             visible : true,
             display_order : 10
          },
          {
             display_value :  'Solar (Non-professional Installed)' ,
             internal_value :  'SolarNPI' ,
             visible : true,
             display_order : 11
          },
          {
             display_value :  'Solar (Professional Installed)' ,
             internal_value :  'SolarPI' ,
             visible : true,
             display_order : 12
          },
          {
             display_value :  'Wood (Non-professional Installed)' ,
             internal_value :  'WoodNPI' ,
             visible : true,
             display_order : 13
          },
          {
             display_value :  'Wood (Professional Installed)' ,
             internal_value :  'WoodPI' ,
             visible : true,
             display_order : 14
          },
          {
             display_value :  'Other' ,
             internal_value :  'Other' ,
             visible : true,
             display_order : 15
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_HeatingUpdateStatus' ,
         field_type :  'radio' ,
         label :  'Heating Update' ,
         field_value :  'Complete' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 430,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :  'Utility Information' ,
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url : ''  
          },
          {
             rule_type :  'api' ,
             trigger :  'onchange' ,
             rule_name :  'ManageHeatingUpdateStatus' ,
             rule :'', 
             rule_url :  '/rules/ManageHeatingUpdateStatus/QTE_PRP_HeatingUpdateStatus' 
          }
        ],
         values : [
          {
             display_value :  'None' ,
             internal_value :  'None' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'Partial' ,
             internal_value :  'Partial' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :  'Complete' ,
             internal_value :  'Complete' ,
             visible : true,
             display_order : 3
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_HeatingUpdatedYear' ,
         field_type :  'text_inline' ,
         label :  'Updated Year' ,
         field_value :  2020 ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 440,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :  'YYYY',
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 4,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :  'Utility Information' ,
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'RequiredYearFormat' ,
             rule :  '{ \ required\ : true, \ digits\ :4 }' ,
             rule_url :''   
          },
          {
             rule_type :  'api' ,
             trigger :  'onblur' ,
             rule_name :  'ValidateHeatingUpdatedYear' ,
             rule :'', 
             rule_url :  '/rules/ValidateHeatingUpdatedYear/QTE_PRP_HeatingUpdatedYear' 
          }
        ],
         values : [
          
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_HasWoodBurningStove' ,
         field_type :  'radio' ,
         label :  'Wood Burning Stove' ,
         field_value :  'N' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 450,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :  'Utility Information' ,
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url : ''  
          },
          {
             rule_type :  'api' ,
             trigger :  'onchange' ,
             rule_name :  'ManageHasWoodBurningStove' ,
             rule :'', 
             rule_url :  '/rules/ManageHasWoodBurningStove/QTE_PRP_HasWoodBurningStove '
          }
        ],
         values : [
          {
             display_value :  'Yes' ,
             internal_value : 'Y' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'No' ,
             internal_value :  'N' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_NumWoodBurningStoves' ,
         field_type :  'text_inline' ,
         label :  'Number of Wood Burning Stoves' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 460,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : false,
         is_required : true,
         script :'', 
         max_length : 3,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :  'Utility Information' ,
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'RequiredNumericMinValueOne' ,
             rule :  '{ \ required\ : true, \ numeric\ : true, \ min_value\ : 1 }' ,
             rule_url : ''  
          }
        ],
         values : [
          
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_HasFireplaces' ,
         field_type :  'radio' ,
         label :  'Fireplace(s)' ,
         field_value :  'N' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 470,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :  'Utility Information' ,
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url :''   
          },
          {
             rule_type :  'api' ,
             trigger :  'onchange' ,
             rule_name :  'ManageHasFireplaces' ,
             rule :'', 
             rule_url :  '/rules/ManageHasFireplaces/QTE_PRP_HasFireplaces' 
          }
        ],
         values : [
          {
             display_value :  'Yes' ,
             internal_value :  'Y' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'No' ,
             internal_value :  'N' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_NumFireplaces' ,
         field_type :  'text_inline' ,
         label :  'Number of Fireplaces' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 480,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : false,
         is_required : true,
         script :'', 
         max_length : 3,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :  'Utility Information' ,
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'RequiredNumericMinValueOne' ,
             rule :  '{ \ required\ : true, \ numeric\ : true, \ min_value\ : 1 }' ,
             rule_url : ''  
          }
        ],
         values : [
          
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_FireplaceType' ,
         field_type :  'select_medium' ,
         label :  'Fireplace Type' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 490,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : false,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :  'Utility Information' ,
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :  'Single' ,
             internal_value :  'Single' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'Double' ,
             internal_value :  'Double' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :  'Triple' ,
             internal_value :  'Triple' ,
             visible : true,
             display_order : 3
          },
          {
             display_value :  'Direct' ,
             internal_value :  'Direct' ,
             visible : true,
             display_order : 4
          },
          {
             display_value :  'Gas' ,
             internal_value :  'Gas' ,
             visible : true,
             display_order : 5
          },
          {
             display_value :  'Zero Clearence (Pre-Fab)' ,
             internal_value :  'ZeroClearence' ,
             visible : true,
             display_order : 6
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_ElectricalUpdateStatus' ,
         field_type :  'radio',
         label :  'Electical Update' ,
         field_value :  'Complete' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 500,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :  'Utility Information' ,
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type : 'js' ,
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url :''   
          },
          {
             rule_type : 'api' ,
             trigger :  'onchange' ,
             rule_name :  'ManageElectricalUpdateStatus' ,
             rule :'', 
             rule_url :  '/rules/ManageElectricalUpdateStatus/QTE_PRP_ElectricalUpdateStatus' 
          }
        ],
         values : [
          {
             display_value :  'None' ,
             internal_value :  'None' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'Partial' ,
             internal_value :  'Partial' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :  'Complete' ,
             internal_value :  'Complete' ,
             visible : true,
             display_order : 3
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_ElectricalUpdatedYear' ,
         field_type :  'text_inline' ,
         label :  'Updated Year' ,
         field_value :  '2020' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 510,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :  'YYYY',
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 4,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :  'Utility Information' ,
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'RequiredYearFormat' ,
             rule :  '{ \ required\ : true, \ digits\ :4 }' ,
             rule_url : ''  
          },
          {
             rule_type :  'api' ,
             trigger :  'onblur' ,
             rule_name :  'ValidateElectricalUpdatedYear' ,
             rule :'', 
             rule_url :  '/rules/ValidateElectricalUpdatedYear/QTE_PRP_ElectricalUpdatedYear' 
          }
        ],
         values : [
          
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_ElectricCircuitBreaker' ,
         field_type :  'radio' ,
         label :  'Electric Circuit Breaker' ,
         field_value :'', 
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 520,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : false,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :  'Utility Information' ,
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :  'Yes' ,
             internal_value :  'Y' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'No' ,
             internal_value :  'N' ,
             visible : true,
             display_order : 2
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_PlumbingUpdateStatus' ,
         field_type :  'radio' ,
         label :  'Plumbing Update' ,
         field_value :  'Complete' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 530,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :  'Utility Information' ,
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url :''   
          },
          {
             rule_type :  'api' ,
             trigger :  'onchange' ,
             rule_name :  'ManagePlumbingUpdateStatus' ,
             rule :'', 
             rule_url :  '/rules/ManagePlumbingUpdateStatus/QTE_PRP_PlumbingUpdateStatus' 
          }
        ],
         values : [
          {
             display_value :  'None',
             internal_value :  'None',
             visible : true,
             display_order : 1
          },
          {
             display_value :  'Partial' ,
             internal_value :  'Partial' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :  'Complete' ,
             internal_value :  'Complete' ,
             visible : true,
             display_order : 3
          }
        ],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_PlumbingUpdatedYear' ,
         field_type :  'text_inline' ,
         label :  'Updated Year' ,
         field_value :  2020 ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 540,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder : 'YYYY' ,
         visible : true,
         is_quote_summary_field : 'false',
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 4,
         section :  'Additional Information',
         section_type :'', 
         sub_section :  'Utility Information',
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name : 'RequiredYearFormat' ,
             rule :  '{ \ required\ : true, \ digits\ :4 }' ,
             rule_url :''   
          },
          {
             rule_type :  'api' ,
             trigger :  'onblur' ,
             rule_name :  'ValidatePlumbingUpdatedYear' ,
             rule :'', 
             rule_url :'/rules/ValidatePlumbingUpdatedYear/QTE_PRP_PlumbingUpdatedYear' 
          }
        ],
         values : [],
         has_error : false,
         error : null
      },
      {
         field_name :  'QTE_PRP_PrimaryCoolingSource' ,
         field_type :  'select_medium' ,
         label :  'Primary Cooling Source' ,
         field_value :  'CentralACSameDucts' ,
         group_id : 11,
         index : null,
         sub_index : null,
         display_order : 550,
         section_display_order : 2,
         help_text :'', 
         sub_text :'', 
         placeholder :'', 
         visible : true,
         is_quote_summary_field : false,
         is_enabled : true,
         is_required : true,
         script :'', 
         max_length : 100,
         section :  'Additional Information' ,
         section_type :'', 
         sub_section :  'Utility Information' ,
         sub_section_type :'', 
         sub_index_section :'', 
         sub_index_section_type :'', 
         rules : [
          {
             rule_type :  'js' ,
             trigger :'', 
             rule_name :  'FieldRequired' ,
             rule :  '{ \ required\ : true }' ,
             rule_url :''   
          }
        ],
         values : [
          {
             display_value :  'None' ,
             internal_value :  'None' ,
             visible : true,
             display_order : 1
          },
          {
             display_value :  'Central AC (Same Ducts)' ,
             internal_value :  'CentralACSameDucts' ,
             visible : true,
             display_order : 2
          },
          {
             display_value :  'Central AC (Separate Ducts)' ,
             internal_value :  'CentralACSeparateDucts' ,
             visible : true,
             display_order : 3
          },
          {
             display_value :  'Evaporative Cooler' ,
             internal_value :  'EvaporativeCooler' ,
             visible : true,
             display_order : 4
          },
          {
             display_value :  'Wall Unit' ,
             internal_value :  'WallUnit' ,
             visible : true,
             display_order : 5
          },
          {
             display_value : 'Whole House Fan' ,
             internal_value :  'WholeHouseFan' ,
             visible : true,
             display_order : 6
          }
        ],
         has_error : false,
         error : null
      }
    ],
    state: null,
    blurbs: [],
    quote_summary: {
      quote_status: 'Rate1',
      is_created_in_qrp_for_epic: false,
      is_exportable_to_epic: false,
      quote_summary_sections: [
        {
          label: 'Named Insured',
          content: [
            {
              "fields": [
                {
                  "label": "Name",
                  "field_value": "Test Mercury"
                },
                {
                  "label": "Address",
                  "field_value": "1085 Sandy Plains Road Leeds, NY 12451"
                },
                {
                  "label": "Email",
                  "field_value": "Test@email.com"
                },
                {
                  "label": "Phone",
                  "field_value": "9876543210"
                }
              ]
            }
          ] 
       }
      ] 
    }   
  }
  }
  export default fallbackDataRcTwo;   

    
    
  


//////////////////
// WEBPACK FOOTER
// ./config/admin/fallbackDataRcTwo.js
// module id = null
// module chunks = 